/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import uniqLib from 'lodash-es/uniq';

export const uniq = uniqLib;
